import React from 'react';
import { Typography } from '@material-ui/core';

const TextTypo = ({
	text,
	align = 'inherit',
	color = 'initial',
	gutterBottom = false,
	variant = 'body1',
}) => {
	return (
		<div>
			<Typography
				align={align}
				color={color}
				gutterBottom={gutterBottom}
				variant={variant}
			>
				{text}
			</Typography>
		</div>
	);
};

export default TextTypo;
